/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Overview_Current_PlanInputs */

const es_admin_company_overview_current_plan = /** @type {(inputs: Admin_Company_Overview_Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan actual`)
};

const en_admin_company_overview_current_plan = /** @type {(inputs: Admin_Company_Overview_Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current plan`)
};

/**
* | output |
* | --- |
* | "Current plan" |
*
* @param {Admin_Company_Overview_Current_PlanInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_company_overview_current_plan = /** @type {((inputs?: Admin_Company_Overview_Current_PlanInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Overview_Current_PlanInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_company_overview_current_plan(inputs)
	return en_admin_company_overview_current_plan(inputs)
});
export { admin_company_overview_current_plan as "admin.company_overview.current_plan" }